import { Component, Vue } from "vue-property-decorator"
import {
    getMarketCooperationAdviserList, getMarketCooperationConsultByMarketCooperationId,
    setMarketCooperationConsult,
    uploadFile
} from '@/api/common'
import { formatDate } from '@/utils/timeFilter'
import { Loading } from "element-ui"
import axios from "axios";
import {makeUploadSignature} from "@/utils/uploadMd5";

@Component({
    filters: {
        dataFilter: (val: string) => (formatDate('yyyy-MM-dd hh:mm', new Date(val)))
    }
})
export default class Consult extends Vue {
    /* data */
    id: number | undefined
    name = ''
    address = '' // 地点
    price = '' // 花费
    date = new Date()
    time = new Date().getHours() + ':00'
    content = '' // 拜访的主要内容
    marketCooperationAdviserId: number | undefined
    marketCooperationAdviserName = ''
    tableData: any[] = []
    page = 1
    limit = 20
    total = 0
    timePickerOptions = { start: '00:00', step: '01:00', end: "23:59" }
    enclosureList = [
        {name: '', url: ''}
    ]
    marketCooperationAdviserList = []
    axios = null
    loading = false
    signature = ''

    /* created() */
    created() {
        const query = this.$route.query
        if (query.id) {
            this.id = Number(query.id)
            this.name = query.name as string
            this.getTableData()
        }
        this.$nextTick(() => {
            (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.addEventListener('scroll', (res: any) => {
                const height = res.target;
                const clientHeight = height.clientHeight;
                const scrollTop = height.scrollTop;
                const scrollHeight = height.scrollHeight;
                if (clientHeight + scrollTop >= scrollHeight) {
                    if(this.tableData.length >= this.total) {

                        return
                    }
                    this.limit += 20
                    this.getTableData()
                }
            }, true);
        })
        this.getMarketCooperationAdviserList()
        this.createAxios()
    }
    /* methods */
    createAxios() {
        const origin = location.hostname; //当前访问域名
        let requestBase = "";
        if (process.env.NODE_ENV === "development") {
            requestBase = process.env.VUE_APP_BASE_FILE_API_PROXY;
            // requestBase = process.env.VUE_APP_TESTFIELE_SEAVER_API;
        } else {
            if (origin.indexOf("-testserver") > -1) {
                requestBase = process.env.VUE_APP_DEV_FILE_API;
            } else {
                requestBase = process.env.VUE_APP_MASTER_FILE_API;
            }
        }
        const config = {
            baseURL: requestBase,
            timeout: 30 * 1000, // Timeout
        };
        this.axios = axios.create(config);
    }
    async getMarketCooperationAdviserList() {
        const result: any = await getMarketCooperationAdviserList({marketCooperationId: this.id as number})

        this.marketCooperationAdviserList = result.marketCooperationAdviserList
    }

    handleAdviserChange(val) {
        this.marketCooperationAdviserId = val
    }


    async getTableData() {
        this.loading = true
        await getMarketCooperationConsultByMarketCooperationId({
            marketCooperationId: this.id as number,
            page: this.page,
            limit: this.limit
        }).then((data: any) => {
            this.total = data.allNum
            this.tableData = data.marketCooperationConsultList.map((item: any) => ({...item, readonly: true}))
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
        // console.log(this.tableData);
    }
    async setMarketCooperationConsult() {
        if (!this.marketCooperationAdviserId) {
            this.$message.error('请选择送生顾问')
            return
        }
        if (!(this.address && this.price && this.date && this.time && this.content)) {
            this.$message.error(`
                ${this.address ? '' : '咨询地点，'}
                ${this.price ? '' : '花费金额，'}
                ${this.date ? '' : '咨询日期，'}
                ${this.time ? '' : '咨询时间，'}
                ${this.content ? '' : '咨询主要内容'}
                不能为空
            `)
            return
        }
        await setMarketCooperationConsult({
            marketCooperationId: this.id,
            marketCooperationAdviserId: this.marketCooperationAdviserId,
            address: this.address,
            price: this.price,
            consultAt: formatDate('yyyy-MM-dd', new Date(this.date)) + ' ' + this.time + ':00',
            content: this.content,
        })
        this.$message.success("新建拜访记录成功")
        this.address = '' // 地点
        this.price = '' // 花费
        this.date = new Date() // 日期
        this.time = new Date().getHours() + ':00' // 时间
        this.content = '' // 咨询主要内容
        this.getTableData()
    }

    async confirmRow(row: any) {
        const obj = {...row}
        obj.price = String(obj.price)
        obj.marketCooperationId = this.id
        obj.consultAt = this.dealdate(obj.consultAt)
        await setMarketCooperationConsult(obj)
        row.readonly = true

    }

    dealdate(dealdate) {
        const date = new Date(dealdate)
        const year = date.getFullYear()
        let month: string | number = date.getMonth() + 1
        month = month < 10 ? "0" + month : month
        let day: string | number = date.getDate()
        day = day < 10 ? "0" + day : day
        let hour: string | number = date.getHours()
        hour = hour < 10 ? "0" + hour : hour
        let minute: string | number = date.getMinutes()
        minute = minute < 10 ? "0" + minute : minute
        let second: string | number = date.getSeconds()
        second = second < 10 ? "0" + second : second
        return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
    }

    async uploadFile(row: any, e: any) {
        const loading = Loading.service({ text: '正在上传文件' })
        const file = e.target.files[0]
        const formdata = new FormData()
        formdata.append('file', file, file.name)
        formdata.append('bucket', 'crm')
        this.signature = makeUploadSignature('crm', file.name)
        formdata.append('signature', this.signature)
        this.axios.post(
            "/upload/upload",
            formdata
        ).then(res => {
            const data: any = res.data.data
            row.enclosureList.push({
                name: data.name,
                url: data.ossUrl
            })
            this.$nextTick(() => {
                loading.close()
            })
        }).catch(error=>{
            console.log(error)
        })
    }
    delFile(row: any, index: number) {
        row.splice(index, 1)
    }

    inputPrice(val){
        if(isNaN(val)) {
            this.$message.warning('请输入数字')
            this.price = ''
            return
        }
    }
}
